import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import { ReportTags } from "./ReportTags";
import type { ToeReportRowDto } from "@/api/dtos";
import type { ToeReportRow } from "./_models/ToeReport";
import { toToeReportRowFromDto } from "./_transformers/toToeReportRowFromDto";

/** The merged TOE dashboard export (GET /sandbox/toe-report) built by process-toe: { total, rows }. */
export const getToeReportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getToeReport: builder.query<ToeReportRow[], void>({
      queryFn: async () => {
        try {
          const res = await axios.get<{ total: number; rows: ToeReportRowDto[] }>(
            `${backendBase()}/sandbox/toe-report`,
            { headers: { Accept: "application/json" } },
          );
          const rows = res.data.rows.map((x) => toToeReportRowFromDto(x));
          return { data: rows };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
      providesTags: [{ type: ReportTags.ToeReport, id: "LIST" }],
    }),
  }),
});

export const getToeReport = getToeReportApi.endpoints.getToeReport;
